function streamText(text, element, delay = 100) {
    let index = 0;

    // 使用 setInterval 逐字输出
    const interval = setInterval(() => {
        if (index < text.length) {
            element.textContent += text[index]; // 添加当前字符
            index++;
        } else {
            clearInterval(interval); // 停止定时器
        }
    }, delay);
}

export default streamText;
